export default __webpack_public_path__ + "static/media/aiColumn-success.0882da9b.svg";